const AcikRizaOnayi = (props) => {
  return (
    <>
      <div
        className="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
        id="acikRizaOnayi"
        tabIndex="-1"
        aria-labelledby="acikRizaOnayiLabel"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-lg relative w-auto pointer-events-none">
          <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="modal-body relative p-4">
              <h4 className="text-gray-800 font-semibold text-xs">
                AÇIK RIZA ONAYI
              </h4>{" "}
              <br /> Sayın Çalışan Adayımız,
              <br />
              <br />
              <p className="text-xs">
                İş başvurunuz sırasında mtstaj.co üzerinde Özgeçmişiniz (CV)’niz
                veya Ön Yazınız aracılığı ile özel nitelikli kişisel veri olan
                ırk,&nbsp;<span className="whitespace-nowrap">etnik köken</span>
                ,&nbsp;
                <span className="whitespace-nowrap">siyasi düşünce</span>,
                felsefi inanç, din, mezhep veya diğer inançlar, kılık ve
                kıyafet, dernek, vakıf ya da sendika üyeliği, sağlık, cinsel
                hayat, ceza mahkûmiyeti ve güvenlik tedbirleriyle ilgili veriler
                ile biyometrik ve genetik verileriniz hakkında bilgi
                paylaşmamanızı rica ederiz. <br />
                <br />
                Ray Sigorta A.Ş. ile özel nitelikli kişisel verilerinizi
                paylaşmanız durumunda, bu verilerinizin açık rızanıza dayalı
                olarak paylaşıldığı kabul edilecektir.
              </p>
            </div>
            <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                className="px-4 py-2 mr-2 bg-custom-red text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-600 hover:shadow-lg focus:bg-red-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-600 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Kapat
              </button>
              <label
                htmlFor={!props.isChecked ? "riza-onayi" : ""}
                data-bs-dismiss="modal"
                className="px-4 py-2 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-600 hover:shadow-lg focus:bg-green-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-600 active:shadow-lg transition duration-150 ease-in-out cursor-pointer"
              >
                Onaylıyorum
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AcikRizaOnayi;
